import { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";
import { parsePhoneNumberFromString } from "libphonenumber-js/min";

export default function BookingPhone({ value }) {
  const [copyState, setCopyState] = useState("");
  const raw = typeof value === "string" ? value.trim() : "";
  const candidate = /^\d{11,15}$/.test(raw) ? `+${raw}` : raw;
  const phone = parsePhoneNumberFromString(candidate);
  const label = phone?.isPossible() ? phone.formatInternational() : raw;
  useEffect(() => { setCopyState(""); }, [raw]);
  useEffect(() => {
    if (!copyState) return;
    const timer = setTimeout(() => setCopyState(""), 2000);
    return () => clearTimeout(timer);
  }, [copyState]);
  if (!raw) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(raw); setCopyState("copied"); }
    catch { setCopyState("failed"); }
  };
  return <span className="inline-flex items-center gap-1 whitespace-nowrap font-normal text-slate-600">
    <span className="tabular-nums">{label}</span>
    <button type="button" aria-label="Copy phone number" title={copyState === "copied" ? "Copied" : "Copy phone number"} onClick={copy}
      className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded text-slate-500 hover:bg-slate-100 hover:text-emerald-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-600">
      {copyState === "copied" ? <Check size={13} aria-hidden="true"/> : <Copy size={13} aria-hidden="true"/>}
    </button>
    <span role="status" className="sr-only">{copyState === "copied" ? "Phone number copied" : copyState === "failed" ? "Could not copy. Select the number to copy it." : ""}</span>
  </span>;
}
